export default __webpack_public_path__ + "static/media/Thaumaturge's Gauntlets of the Mandate.9364f53d.jpg";